import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';
import * as errorHandlingActions from './error-handling.actions';
import {logErrorIfInDev} from './log-error.operator';
import {EventEmitterService} from '../event-emitter/event-emitter.service';

@Injectable()
export class ErrorHandlingEffects {
  uncaughtError$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(
          errorHandlingActions.uncaughtError,
          errorHandlingActions.unrecoverableError,
        ),
        tap(error => {
          this.eventEmitterService.addOnError({
            message: error.error.message,
            code: error.error?.code || 500,
            data: {...error},
          });
          this.router.navigate([{outlets: {commerceElement: 'error'}}]);
        }),
      );
    },
    {dispatch: false},
  );

  logError$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(errorHandlingActions.logError),
        logErrorIfInDev(),
      );
    },
    {dispatch: false},
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private eventEmitterService: EventEmitterService,
  ) {}
}
